import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';


import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EditPractitionerGroupDialogModule } from '../../components/edit-practitioner-group-dialog/edit-practitioner-group-dialog.module';
import { AlertDefinitionsComponent } from './alerts.component';
import { EditAlertDialogModule } from '../../components/edit-alert-dialog/edit-alert-dialog.module';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EditAlertDialogModule,
        MatButtonModule,
        MatIconModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        AlertDefinitionsComponent
    ],
    exports: [
        AlertDefinitionsComponent
    ]
})
export class AlertDefinitionsModule { }
